import * as yup from 'yup';

export const campaignFormSchema = yup.object().shape({
  title: yup.string().required(),
});
